export default {
    setDictList(state, data) {
        state.dictList = data
    },
    setTableData(state, data) {
        state.tableData = data.tableData || []
        state.cardData = data.cardData || []
        state.statData = data.stat || {}
    },
    setSpecialityList(state, data) {
        state.specialityList = data.specialityList || []
        state.specialityListError = data.error || false
        state.emptyPredict = data.emptyPredict || false
        state.tableData = []
    },
    setSpecialityGroup(state, data) {
        state.specialityGroup = data.specialityGroup || []
    },
    setSpecialityGroupLoading(state, data) {
        state.specialityGroupLoading = data
    },
    setTableDataLoading(state, data) {
        state.tableDataLoading = data
    },
    setSpecialityListLoading(state, data) {
        state.specialityListLoading = data
    },
    setForm(state, data) {
        state.form = data
    },
    setMenuOpen(state, data) {
        state.menuOpen = data
    }
}
